// 配置表格的列宽度
export const TYPE_WIDTH = 100
export const AMOUNT_WIDTH = 200
export const TOTAL_AMOUNT_WIDTH = 200
export const INDATE_WIDTH = 180
export const INDATE_START_WIDTH = 200
export const TERM_WIDTH = 150
export const LIMIT_CONDITION_WIDTH = 400
export const ACTION_WIDTH = 150

export const SCROLL = { x: 800 }
